type QuoteSendCandidate = {
  quoteStatus?: string;
};

export function filterUnsentQuoteIDs(
  quoteIDsToSend: string[],
  selectedSystems: Array<QuoteSendCandidate & { uniqueId: string }>,
  selectedDuctedSystems: Array<QuoteSendCandidate & { id: number | string }>
): string[] {
  const sentIds = new Set([
    ...selectedSystems
      .filter((system) => system.quoteStatus === 'sent')
      .map((system) => system.uniqueId),
    ...selectedDuctedSystems
      .filter((system) => system.quoteStatus === 'sent')
      .map((system) => system.id.toString())
  ]);

  return Array.from(new Set(quoteIDsToSend)).filter((id) => !sentIds.has(id));
}
